import { Button, Icon, Tooltip } from '@lightspeed/design-system-react'
import { ApiRetailerPaymentType } from '@vend/types'
import React, { FunctionComponent, useEffect, useState } from 'react'
import { T, useT } from '@transifex/react'
import { useAppSelector } from '../../../state/hooks'
import { selectOutstandingBalance } from '../../../state/slices/currentSale/currentSaleSlice'
import {
  useHotkeysService,
  useWebRegisterStatusManager,
} from '../../../ng-compat/hooks'
import { EVENTS } from '../../../constants'

export interface Props {
  paymentType?: ApiRetailerPaymentType
  disabled?: boolean
}

export const LSPayButton: FunctionComponent<Props> = ({
  paymentType,
  disabled,
}) => {
  const webRegisterStatusManager = useWebRegisterStatusManager()
  const [isOffline, setIsOffline] = useState<boolean>(
    !webRegisterStatusManager.isOnline()
  )
  const outstandingBalance = useAppSelector(selectOutstandingBalance)
  const hotkeysService = useHotkeysService()
  const t = useT()

  useEffect(() => {
    webRegisterStatusManager.on(EVENTS.transitionOnline, () =>
      setIsOffline(false)
    )
    webRegisterStatusManager.on(EVENTS.transitionOffline, () =>
      setIsOffline(true)
    )
  }, [setIsOffline, webRegisterStatusManager])

  // TODO: implement.
  const handleClick = () => {}

  useEffect(() => {
    const config = {
      summary: t('Select payment option 1', {
        _context: 'Hot key summary for the Lightspeed Payments pay button',
      }),
      combo: `alt+1`,
      count: true,
      action: () => handleClick(),
    }
    hotkeysService.add(config)

    return () => {
      hotkeysService.remove(config.combo)
    }
  }, [t, hotkeysService])

  if (!paymentType) {
    return
  }

  return (
    <Tooltip
      className="wr-tooltip"
      direction="center"
      message={
        <T
          _str="You need to be connected to the internet to take payments using this payment type."
          _context="tooltip message for lightspeed payments when offline"
          lineBreak={<br />}
        />
      }
      header={t('You can’t use this payment type while offline.', {
        _context: 'tooltip message for lightspeed payments when offline',
      })}
      canBeShown={isOffline}
      icon="info-circle"
    >
      <Button
        onClick={handleClick}
        variant={outstandingBalance < 0 ? 'no' : 'go'}
        className="vd-btn vd-btn--jumbo vd-pt5 vd-pb5 vd-mt5"
        data-hotkey-tip="1"
        disabled={!!disabled || isOffline}
      >
        <Icon icon="credit-card" />
        <span className="vd-ml2">{paymentType.name}</span>
      </Button>
    </Tooltip>
  )
}
